import { render } from "./FileUpload.vue?vue&type=template&id=56a7e576&scoped=true"
import script from "./FileUpload.vue?vue&type=script&lang=js"
export * from "./FileUpload.vue?vue&type=script&lang=js"

import "./FileUpload.vue?vue&type=style&index=0&id=56a7e576&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-56a7e576"

export default script